export default {
    template: `
        <div class="moat-table-custom-status-bar-sum display-flex align-items-center py-sm ml-md">
            <p class="extra-small text-truncate">{{ params.sumTitle }}: </p>
            <p class="bold extra-small text-truncate ml-xs">{{ params.value }}</p>
            <div v-if="params.sectionBreak" class="mr-xs ml-lg bg-primary" style="width: 2px; height: 15px;"></div>
        </div>
    `,
    setup(props) {
        return {}
    },
}
